<template>
<!-- 节目主页  节目结束主页 -->
  <div class="programStop"  v-wechat-title="this.title" >
     <!-- <splite-light></splite-light> -->
     
     <!-- <div class="compere-stop"> -->
       <!-- <div class="compereMes">
          <p class="liveStop" v-show="isendShare==1" >直播已结束</p>
          <p class="comImg" :class="isendShare==0?'marginT':''"><img :src="programMsg.avatar" alt=""></p>
          <p class="comName">{{programMsg.title}}</p>
          <div class="hostsMsg" :class="isendShare==0?'marginT':''" >
          <p class="liveName" ><span>主持人：</span><font v-for="(item,index) in hosts" :key="index"> {{item.nickname}}</font></p>
          <p class="liveTime">{{programMsg.date_show}}</p>
        </div>
       </div>
     <div class="downloadApp" @click="toDownloadpage">
      <img src="../../assets/btn@2x.png" alt="" >
    </div> -->

<div style="width: 100%;height:100%;box-sizing: border-box;overflow-y: scroll;overflow-x: hidden;-webkit-overflow-scrolling: auto;font-size: .24rem;"  ref="wrapper" :style="{ height: (wrapperHeight) + 'px' }">
    <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" bottomPullText="" bottomDropText="正在加载..." ref="loadmore" :auto-fill="false">


      <div class="programContainer" v-if="isendShare==0">
    <div class="header_download flex">
      <div class="flex">
        <img class="logo2" src="../../assets/logo2.png" alt="" />
        <img class="voiceLogo2" src="../../assets/voiceLogo2.png" alt="" />
      </div>
      <img src="../../assets/btn_download2.png" alt="下载" class="download" @click="toDownloadpage"/>
    </div>
    <div class="compere-stop">
      <div class="comName">{{ programMsg.title }}</div>
      <div class="radio" style="padding-top:.16rem">电台：{{ programMsg.radio_name }}</div>
      <div class="display_window flex" v-if="programMsg.shop_url" @click="shopUrl()">
        <img class="img1" src="../../assets/house2.png" alt="" />
        <div>{{programMsg.shop_name}}</div>
        <img class="img2" src="../../assets/right1.png" alt="" />
      </div>
      <div class="flex get">
        <div class="flex">
         
          <div class="text_num">{{ programMsg.stars | peopleNumber }}<span v-if="programMsg.stars !== undefined && programMsg.stars.length >= 5" style="font-size: 0.25rem;">w</span></div>
          
          <div class="text_text">点赞</div>
        </div>
        <div class="flex">
          <div class="text_num">{{ programMsg.fans | peopleNumber }}<span v-if="programMsg.fans !== undefined && programMsg.fans.length >= 5" style="font-size: 0.25rem;">w</span></div>
          <div class="text_text">粉丝</div>
        </div>
        <div class="flex">
          <div class="text_num">{{ programMsg.score | peopleNumber }}<span v-if="programMsg.score !== undefined && programMsg.score.length >= 5" style="font-size: 0.25rem;">w</span></div>
          <div class="text_text">活跃值</div>
        </div>
      </div>
      <div class="flex" style="overflow-x:scroll; margin-left:.24rem;">
          <div class="flex people" v-for="(item,index) in programMsg.hosts" :key="index">
          <!-- <div class="headmark" > -->
            <!-- <img v-if="index == 0" style="width:1.24rem;height:1.24rem" src="../../assets/headmark.png" alt=""> -->
            <!-- <div v-if="index == 0" style="width:1.24rem;height:1.24rem"></div> -->
            <img class="avatar" :src="item.avatar" alt="" />
          <!-- </div> -->
          <div class="item" :style="index == 0 ? 'margin-left:.1rem' : 'margin-left:.2rem'">
            <div class="name">{{item.nickname}}</div>
            <div class="tag" v-if="item.label" :style="item.backgroundColor">{{item.label}}</div>
          </div>
        </div>
      </div>
      <div class="flex notice">
        <div class="flex">
          <div class="notice_text">下档预告</div>
          <div class="time">{{programMsg.notice}}</div>
        </div>
        <img class="img" src="../../assets/time_1.png" alt="" />
      </div>

    </div>
          <div class="tabContent">
            <div class="table-bar">
        <div class="table-bar-item" @click="checkTab(item.order)" :class="currentTab == item.order? 'table-bar-item-active': 'table-bar-item-default'" v-for="(item, index) in tableBar"
          :key="index"
        >
          {{ item.name }} <b></b>
        </div>
      </div>
      <div class="table_bar_item" v-if="currentTab == '1'">
        <programcommen1 v-if="recommendRecorded.length && recommendRecorded.length > 0" :commenPrograms='recommendRecorded'></programcommen1>
        <div v-else class="noList">暂无节目</div>
      </div>
      <div class="table_bar_item" v-if="currentTab == '2'">
        <works v-if="worksList.length > 0" :commenProgram="worksList"></works>
        <div v-else class="noList">暂无视频</div>
      </div>
      <div class="table_bar_item" v-if="currentTab == '3'">
        <div class="title">所属电台</div>
        <div class="radio_name flex"><p class="spot"></p>{{ProgrammeIndex.radio_name}}</div>
        <div class="radio_text">{{ProgrammeIndex.radioInfo}}</div>
        <div class="title">所属频率</div>
        <div class="radio_name flex"><p class="spot"></p>{{ProgrammeIndex.channel_name}}</div>
        <div class="radio_text">{{ProgrammeIndex.channelInfo}}</div>
        <div class="title">节目介绍</div>
        <div class="radio_text">{{ProgrammeIndex.programmeInfo}}</div>
      </div>
          </div>

    </div>
    
<div v-if="isendShare==1">
 
        <div class="pro-Rec" >
        <div  class="toRecorded" style="width:100%;height:4.22rem;">
          <div class="caption">
            <div class="split">
              <hr>
            </div>
            <div class="caption-name">直播已结束</div>
            <div class="split">
              <hr>
            </div>
          </div>
          <div class="showTime">
            <span>下档节目</span>
            <span style="margin:0 0.2rem;">{{nextStart}}-{{nextEnd}}</span>
            <span>播出</span>
              <!-- 回放记录生成中,请耐心等待5-10分钟 -->
          </div>
          <div class="lookRecorded lookRecorded1"   v-if="haveRecorded=='1'">
             <img src="../../assets/topRecorded.png" alt="" @click="toRecorded(titles)">
             <img src="../../assets/download.png" alt=""  @click="toDownloadpage">
          </div>
          <div class="lookRecorded"  v-if="noRecorded=='1'">
             <img src="../../assets/toApp.png" alt=""  @click="toDownloadpage">
          </div>

        </div>
        
        <div class="p-msg">
          <p class="topic">
            {{topic}}
          </p>
          <div class="pName">
              <span>{{titles}}</span>
              <span class="dian"></span>
              <p class="num" v-show="isLive=='1'">
                <span>{{show_spectators | peopleNumber }}</span>
                <font v-if="show_spectators.length>=5">w</font>
                人正在看  
              </p>
              <p class="num" v-show="isLive=='0'">
                <span>{{show_spectators | peopleNumber }}</span>
                <font v-if="show_spectators.length>=5">w</font>
                次观看  
              </p>
          </div>

        </div>
        <div class="hostMsg"  v-if="hostMsgs!==undefined && hostMsgs.length > 0 "  >
          <div class="buju">
              <div class="hostTitle">
                主持人阵容({{hostnums}})
              </div>
              <!-- 主持人展示 -->
              <div class="swiper-container" id="hostSwiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"  v-for="(host,index) in hostMsgs"  :key="index">
                    <div class="name">
                        <div>
                          <div class="womenYes womenYes1">
                            <img :src="host.avatar" alt="">
                            <div>
                              <p class="span2" >{{host.nickname}}</p>
                              <p class="span3">{{host.job}}</p>
                            </div>                       
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <!-- <div class="downloadMsg" @click="toDownloadpage">
          <p>
            <img src="../../assets/downNew.png" alt=""  >
          </p>
        </div> -->
         <div class="tips"  v-show="isShow=='1'">
            <p>录播暂未生成</p>
            <p>
               <img src="../../assets/sure.png" alt=""  @click="isHide()">
            </p>
         </div>
         <div class="mark"  v-show="isShow=='1'"></div>
      </div>
      <spliteBold></spliteBold>
      <div class="splite2"></div>
      <hotRecommendBold v-show="programStopRecommend.length>0"></hotRecommendBold>
      <programcommenNew :commenProgram='programStopRecommend'></programcommenNew>
</div>
          </mt-loadmore>
    </div>
      <myfooter :isFrom='footerData'></myfooter> 

  </div>
</template>

<script>
import programcommenNew from '../commen/programcommenNew'
import myfooter from '../commen/myfooter'
import spliteBold from '../commen/spliteBold'
import programcommen1 from "../commen/programcommen1";
import works from "../commen/works";//短视频
import hotRecommendBold from '../commen/hotRecommendBold'
import cbct from '../../../static/js/base.js'
import toast from '../commen/toast.vue'
import qs from 'qs'
import share from '../../../static/js/share.js'
import Swiper from 'swiper'
export default {
  name: 'programStop',
  props: {
  
  },
   data(){
    return {
     hosts:[],
      programStopRecommend:[],
      number:'',
      type:'',
      isendShare:'',
      title:"",
      appName:"-听见广播",
      programMsg:[],
      compereHeadPhoto:[],
      recommendProgram:[],
      topic:'',
      titles:'',
      show_spectators:'0',
      hostImg:'',
      hostMSg:[],
      channelName:'',
      date_show:'',
      isInfo:'2',
      isLive:'',
      isShow:'',
      is_live:'',
      period:'',
      haveRecorded:'',
      noRecorded:'',
      is_play:'',
      play_id:'',
      nextStart:'',
      nextEnd:'',
      period1:'',
      hostMsgs:[],
      hostnums:'',
      tableBar: [
        { name: "节目", order: "1" },
        { name: "短视频", order: "2" },
        { name: "介绍", order: "3" },
      ],
      worksList:[],
      recommendRecorded : [],
      ProgrammeIndex:{},
      allLoaded:true,//是否加载完毕
      wrapperHeight:0,
      page:1,
      currentTab:'1',
      footerData:{name:'lifeLive','isLive':'','number':''}
    }
  },
  computed:{
  },

  filters:{
     peopleNumber:function(n1){
        n1 = n1
         if (n1!="") {
            let strNum="";
         if (n1 >= 0 && n1 < 10000) {
           strNum=n1
         }else{
           strNum=(parseFloat(n1/10000).toFixed(1))
         }
         return strNum     
         }
     }
  },
   methods:{
         loadBottom:function(){//上拉加载
      if (!this.allLoaded) {
        this.page+=1;
        let self =this;
        self.currentTab == '1' ? '' : self.getVideoList()
        this.$refs.loadmore.onBottomLoaded();
      }else{
        this.allLoaded=true;
      }
    },
         //短视频
    getVideoList(){
      let _this = this
      _this.$api.post(cbct.baseurl+"share/video-list",qs.stringify({
        number:_this.number,
        type:1,
        page:_this.page,
        pageSize:10
      })).then(function(res){ 
        console.log(res)
        // res.d.map((item)=>{
        //   item.live_time = _this.handleTime(item.live_time)
        // })
        _this.worksList = _this.worksList.concat(...res.d)
        if(res.d.length == '0' && this.page != '1'){
            _this.allLoaded=false;
        }
      })
    },
    //介绍
    getIndex(){
      let _this = this
      _this.$api.post(cbct.baseurl+"share/programme-index",qs.stringify({
        number:_this.number
      })).then(function(res){
        console.log(res)
        _this.ProgrammeIndex = res.d
      })
    },
         //获取节目
    getPlay(){
      let _this = this
      _this.$api.post(cbct.baseurl+"share/programme-play",qs.stringify({
        // number:'6830877'
        number:_this.number
      })).then(function(res){
        console.log(res)
        // res.d.map(item=>{
        //   item.image = cbct.imgUrl() + item.image
        // })
        _this.recommendRecorded = res.d
      })
    },
    checkTab(order) {
      this.page = 1
      this.currentTab = order;
      if (order == '1') { this.worksList=[],this.allLoaded = true,this.getPlay() }
      if (order == '2') { this.getVideoList(),this.allLoaded = false }
      if(order == '3'){ this.getIndex(),this.allLoaded = true,this.worksList=[] }
    },
    randomRgb(item) {
      let R = Math.floor(Math.random() * 130+110);
      let G = Math.floor(Math.random() * 130+110);
      let B = Math.floor(Math.random() * 130+110);
      console.log( R + ',' + G + ',' + B)
      return {
        background: 'rgb(' + R + ',' + G + ',' + B + ')'
       };
    },
         shopUrl(){
      window.location.replace(this.programMsg.shop_url)
    },
      toDownloadpage(){
         this.$router.push({path:"downloadApp?isFrom=programRecorded&is_live=" +this.isLive +"&number=" +this.number,});
      },
      nextCompere:function(hostId,title){
         this.$router.push({
         path:'compere?type=2&hoster_id='+hostId+'&title='+title
        })

      },
      getDate:function(){
          let self=this;
          self.$api.post(cbct.baseurl+"share/live",qs.stringify({
            'number':this.number,
            'type':this.type,
            'period':this.period
          })).then(function(res){
            if (res.c==cbct.code.successCode) {
              if(res.d.info.is_del){
                  // console.log(res.d.info.is_del)
                  self.$router.push({
                    path:'delPage'
                  })
                return;
              }
              share.share(self,window.location.href,res.d.info.title+'的主页',res.d.info.radio_name,res.d.info.avatar);
            share.QQshare(self,window.location.href,res.d.info.title+'的主页',res.d.info.radio_name,res.d.info.avatar);
              self.programMsg=res.d.info;
              self.hosts=res.d.info.hosts;
              self.title=res.d.info.title+self.appName// 节目直播结束title
              self.hostMsgs=res.d.info.hosts;
              self.hostnums = res.d.info.hosts.length;
              self.hostMSg=res.d.info.hosts[0];
              self.titles=res.d.info.title;
              self.channelName=res.d.info.channel_name;
              self.date_show=res.d.info.date_show;
              self.topic=res.d.live.topic;
              self.isLive=res.d.live.play_id;
              self.is_live=res.d.live.is_live;
              self.is_play=res.d.live.is_play;
              self.$nextTick(function () {
                    self.hosterMsg();
                })
                console.log(self.programMsg)
              // 录播未生成，回放生成
              if(self.is_live=='0' && self.is_play=='-1'){
                self.haveRecorded='1'
                self.play_id=res.d.live.play_id
                self.period1=res.d.live.period
                self.nextStart=res.d.next.start_time
                self.nextEnd=res.d.next.end_time

              }else if(self.is_live=='0' && self.is_play=='-2'){
              //  录播未生成 回放未生成
                self.noRecorded='1'
                self.nextStart=res.d.next.start_time
                self.nextEnd=res.d.next.end_time
              }
              if (res.d.recommend.length>0) {
                  self.programStopRecommend=res.d.recommend;
              }else if(res.d.recommend.length==0){
                self.programStopRecommend=['none'];
              }
            }else{
                  self.bus.$emit('toast',{show:true,title:res.m})
            }
          }).catch((res)=>{
              // this.bus.$emit('toast',{show:true,title:'服务器错误'})
              
         });
      },
      hosterMsg:function(){
        var swiper = new Swiper('#hostSwiper', {
            slidesPerView:'auto',
            spaceBetween: 20,
            observer:true,
            observeParents:true,
            // watchSlidesProgress : true,
            // watchSlidesVisibility : true,
            // on:{
            //     tap: function(){
            //         myPage.slideTo( swiper.clickedIndex)
            //     }
            // }
        })
      },
    getDate1: function () {
      let self = this;
      self.$api.post(cbct.baseurl + "share/home-page",qs.stringify({
            number: this.number,
            type: this.type,
          })
        ).then(function (res) {
          if (res.c == cbct.code.successCode) {
            share.share(self,window.location.href,res.d.title + "的主页",res.d.radio_name,res.d.avatar);
            share.QQshare(window.location.href,res.d.title + "的主页",res.d.radio_name,res.d.avatar);
            res.d.hosts.forEach((element,i) => {
              console.log(element,i)
              if(i=='0'){
                element.backgroundColor = "background: rgba(19, 194, 194, 1)" 
                return ;
              }
              if(i=='1'){
                element.backgroundColor = "background: rgba(146, 84, 222, 1)"
                return
              }
              if(i=='2'){
                element.backgroundColor = "background: rgba(89, 126, 247, 1)"
                return ;
              }
              element.backgroundColor = self.randomRgb()
            });
            self.programMsg = res.d;
            self.title = res.d.title + self.appName;
            if (res.d.info.is_del == "1") {
              self.$router.push({
                path: "delPage",
              });
              return;
            }

            // console.log(res.d.info.title);
            
            // if (res.d.info.hosts != undefined &&res.d.info.hosts.length > 0 &&res.d.info.hosts.length <= 5) {
            //   self.compereHeadPhoto = res.d.info.hosts;
            // }
            // if (res.d.info.hosts != undefined &&res.d.info.hosts.length > 0 &&res.d.info.hosts.length > 5) {
            //   let photos = res.d.info.hosts.slice(0, 5);
            //   self.compereHeadPhoto = photos;
            // }
            // self.recommendProgram = res.d.recommend.programme;
            // self.title = res.d.info.title + self.appName; //节目主页title
          } else {
            self.bus.$emit("toast", { show: true, title: res.m });
          }
        })
        .catch((res) => {
          // this.bus.$emit('toast',{show:true,title:'服务器错误'})
        });
    },
      showInfo:function(){
        this.isInfo='1';
      },
      hideInfo:function(){
        this.isInfo='2';
      },
      toRecorded(titles){ 
         this.$router.push({
              path:'programRecorded?isLive=0&live_id='+this.play_id+'&type=1&title='+titles+'&period='+this.period1
          })
      },
      isHide:function(){
        this.isShow='';
      }
  },
  created(){
    let self=this;
    if(self.$route.query.number){
      self.number=self.$route.query.number;
    }
    if(self.$route.query.programme_id){
      self.number=self.$route.query.programme_id;
    }
    self.period=self.$route.query.period;
    self.type=self.$route.query.type;
    self.isendShare=self.$route.query.isendShare;
    if (self.isendShare=='1'){
      self.getDate();
    }else if(self.isendShare=='0'){
      self.getDate1();
      self.getPlay();
    }
    this.footerData = {name:'lifeLive','isLive':self.isendShare,'number':self.number}
   
  },
  mounted(){
    this.wrapperHeight = document.documentElement.clientHeight;
    // this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
  },
  components: {
      programcommenNew,
      myfooter,
      spliteBold,
      // spliteLight,
      hotRecommendBold,
      programcommen1,
      works
      // share
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
*{
  margin: 0;
  padding: 0;
}
.mint-loadmore{
    // height: 100%;
    // overflow-y: scroll;
  // background: #f7f7f7;
}
.toRecorded{
  width: 100%;
  height: 4.22rem;
  box-sizing: border-box;
  text-align: center;
  background: rgba(0,0,0,.9);

}
.channelName{
  box-sizing: border-box;
  padding: 0.47rem 0;
  border-bottom: solid 1px rgba(222,222,222, 1);
  font-size: 0.32rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: rgba(49, 49, 49, 1);
  
  }
.channelName img{
  width: 0.22rem;
  height: 0.22rem;
  margin-left: 0.16rem;
}
.channelInfo{
  font-size: 0.24rem;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  padding: 0.25rem 0 0.23rem;
  line-height: 1.3;
}
.boldLine{
  height: 0.2rem;
  background: rgba(248, 248, 248, 1)
}


.caption{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 1.54rem;
}
.split{
  flex-grow: 1;
}
.split hr{
    height:0.01rem;
    background:rgba(0,0,0,1);
    opacity:0.55;
    border: none;
    border-top: 2px solid rgba(216,216,216,1);
    margin-top: 0.95rem;
}
.caption-name{
  min-width:1.38rem;
  padding: 0 0.32rem;
  height:0.59rem;
  font-size:0.26rem;
  font-weight:400;
  color:rgba(170,170,170,1);
  line-height:0.59rem;
  margin-top: 0.95rem;

}
.showTime{
  font-size: 0.32rem;
  font-weight:bold;
  color:rgba(255,255,255,1);
  margin: 0.32rem auto 0.41rem;
}
.lookRecorded img{
  width: 2.4rem;
}
.lookRecorded1 img{
 width: 2rem;
}
.lookRecorded1 img:last-of-type{
  margin-left: 0.88rem;
}


.programStop{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: #f7f7f7;
} 
.compere-stop{
  width: 100%;
}
.compereMes{
  width: 100%; 
}
.liveStop{
  width: 100%;
  height: 0.39rem;
  line-height: 0.39rem;
  box-sizing: border-box;
  display: inline-block;
  font-size:0.42rem;
  font-weight:500;
  color:rgba(51,51,51,1);
  margin-top: 0.56rem;
  text-align: center;
}
.comImg{
  width: 1.78rem;
  height: 1.78rem;
  margin:0.4rem auto 0.23rem;
  text-align: center; 
}
.marginT{
  margin: 0.44rem auto 0.24rem;
}
.comImg img{
  width: 100%;
  height: 100%;
  border-radius: 0.2rem;
}

.comName{
  height: 0.4rem;
  box-sizing: border-box;
  margin: 0rem auto 0.33rem;
  text-align: center;
  font-size:0.42rem;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:0.4rem;
}
.comCaption{
width:2.39rem;
height:0.23rem;
font-size:0.24rem;
font-weight:bold;
color:rgba(102,102,102,1);
line-height:0.45rem;
margin: 0.24rem auto 0.3rem;
background: darkgreen;
}
.hostsMsg{
  height: 0.68rem;
  font-size:0.24rem;
  font-weight:400;
  color:rgba(102,102,102,1);
}
.liveName{
  height: 0.22rem; 
  box-sizing: border-box; 
  line-height:0.22rem;
  text-align: center;
}
.liveTime{
  height: 0.22rem;
  line-height: 0.22rem;
  text-align: center;
  margin: 0.24rem auto 0;
}
.downloadApp{
/* height: 1.08rem; */
width: 4.4rem;
box-sizing: border-box;
margin:0.35rem auto 0.34rem;
}
.downloadApp img{
  width: 100%;
  height: 100%;
}
.programContainer{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background-image: url('../../assets/bg.png');
  background-repeat: no-repeat;
  background-size: 100% 8.18rem;
  background-color: #f7f7f7;
}
.Con{
  box-sizing: border-box;
  padding: 0.24rem 0.24rem 0rem 0.24rem;
}
.comMessage{
  width: 100%;
  /* display: flex; */
  /* border: solid 1px; */
}
.comImg{
  width: 1.88rem;
  height: 1.88rem;
  vertical-align: middle;
  /* border: solid 1px; */
}
.comImg>img{
  width: 100%;
  height: 100%;
  border-radius:0.1rem;
}
/* .comMsg>.comname{
  height: 0.4rem;
  color: rgba(34, 34, 34);
  font-size:0.84rem;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:0.4rem;
  font-size: 0.42rem;
} */
.programMsg{
  text-align: left;
  font-size:0.28rem;
  font-weight:500;
  color:rgba(102,102,102,1);
  /* margin-left: 0.01rem; */
  
}
.programMsg p{
  margin: 0.16rem 0;
}


.programMsg p img{
  width: 0.32rem;
  height: 0.32rem;
  vertical-align: middle;
  display: inline-block;
}

.attFens{
  margin-top: 0.22rem;
  height: 0.2rem;
  display: flex;
  align-items: center;
  /* border: solid 1px; */
}
.compereMsg{
  box-sizing: border-box;
  margin-top: 0.34rem;
  margin-bottom: 0.52rem;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.hosts{
  font-size:0.24rem;
  /* font-family:PingFang-SC-Medium; */
  font-weight:500;
  color:rgba(153,153,153,1);
  margin-right: 0.25rem;
}
.headPhoto{

  /* width: 0.88rem; */
  /* margin-right: 0.61rem; */
  width: 19.8%;
}
.headPhoto img{
  width: 0.88rem;
  height: 100%;
  border-radius: 100%;
}
.timeAndhosts{
  height:0.74rem;
  background:rgba(248,248,248,1);
  /* border: solid 1px; */
  margin-top: 0.32rem;
  /* font-family:PingFang-SC-Medium; */
  font-weight:500;
  color:rgba(153,153,153,1);
  line-height:0.74rem;
  /* padding-left:5rem;  */
  margin-bottom: 0.44rem;
  font-size: 14px;
}
.timeAndhosts img{
  width: 0.24rem;
  height: 0.24rem;
  vertical-align: middle;
}
.timeAndhosts img:first-of-type{
  margin: 0 0.38rem 0 0.14rem;
}
.timeAndhosts img:last-of-type{
  margin: 0 0.12rem 0 0.13rem;
}
.min-photo img{
  display: inline-block;
}
.min-name{
  font-size: 0.24rem;
  color: rgba(49,49,49,1);
  margin-top: 0.16rem;
}
.headPhoto .addPng{
  position: absolute;
  width: 0.36rem;
  height: 0.36rem;
  left: 0.72rem;
  top:0.75rem;
}
.pro-Rec{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;

  /* border: solid 1px red; */
} 
/* .active{
  background:rgba(0,0,0,.4) !important;
} */
.tips{
  box-sizing: border-box;
  width: 6rem;
  height: 3.32rem;
  background: white;
  padding: 0.94rem 0 0.34rem;
  /* border: solid 1px; */
  z-index: 1000;
  position: fixed;
  margin:auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;  
}
.tips p{
 font-size: 0.34rem;
 font-weight: bold;
 color: rgba(49, 49, 49,1);
 margin-bottom: 0.77rem;
}
.tips img{
  width: 2.71rem;
}
.mark{
  position: fixed;
  left: 0;
  top: 0;
  opacity: .5;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 998;
}
.p-msg{
    box-sizing: border-box;
    width: 100%;
    height: 1.6rem;
  }
  .p-msg .topic{
    font-size: 0.3rem;
    color: rgba(0, 0, 0, 1);
    font-weight: 500;
    padding: 0.41rem 0 0.05rem 0.32rem;
    line-height: 1;
    text-align: left;
  }
  .p-msg .pName>span{
    color: #000;
    font-size: 0.26rem;
    padding: 0.12rem 0 0 0.36rem;
    float: left;
    opacity: 0.3;
  }
  .p-msg .pName .dian{
    margin: 0.3rem 0.16rem;
    padding: 0;
    width: 0.04rem;
    height: 0.04rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.3);
  }
  .p-msg .pName .num{
    padding: 0.12rem 0 0 0;
    color: #000;
    opacity: 0.3;
  }
.topicandNum{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.topic{
  font-weight: bold;
  font-size: 0.3rem;
  color:rgba(49, 49, 49,1);
  height: 0.42rem;
  line-height: 0.42rem; 
}
.num{
  font-size: 0.24rem;
  color: rgba(91,91,91,1);
  font-weight: 500;
}
.pName{
  text-align: left;
  height: 0.37rem;
  line-height: 0.37rem;
  font-size: 0.26rem;
  color: rgba(102,102,102,1);
}

.rec-Msg{
  padding: 0.26rem 0.23rem 0.24rem; 
  /* border: solid 1px; */
}
.buju{
    height: auto;
    box-sizing: border-box;
    align-items: center;
    // background:rgba(255,255,255,1);
    font-weight:400;
    padding: 0 0.32rem;
    justify-content: space-between;
    border-top: solid 0.02rem rgba(0, 0, 0, 0.1);
    border-bottom: solid 0.02rem rgba(0, 0, 0, 0.1);
  }
  .buju .hostTitle{
    padding: 0;
    font-size:0.26rem;
    line-height: 1;
    color: rgba(0, 0, 0, 1);
    margin:0.25rem 0.32rem 0.47rem 0;
    text-align: left;
    overflow: hidden;
}
.swiper-container{
  width: 100%;
  box-sizing: border-box;
  // background: white;
  padding-bottom: 0.3rem;
  .swiper-slide {
    text-align: center;
    font-size: 0.24rem;
    // background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    width: auto!important;
    margin-right: 15px!important; 
    .name{
      div{
        div{
          width: auto;
          height: auto;
          img{
            float: left;
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 50%;
            margin-right: 0.24rem;
          }
          div{
            float: left;
            height: auto;
            width: auto;
            .span2{
              color: rgba(49, 49, 49, 1);
              font-size: 0.3rem;
              line-height: 1;
              padding: 0.06rem 0;
              text-align: left;
            }
            .span3{
              color: rgba(49, 49, 49, 0.3);
              font-size: 0.24rem;
              line-height: 1;
              padding: 0.05rem 0;
              text-align: left;
            }
          }
        }
      }
    }
  }

}
.mainMsg{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rec-Img{
  width: 0.64rem;
  height: 0.64rem;
  /* border: solid 1px; */
  
}
.rec-Img>img{
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 100%;
}
.rec-Name{
  margin-left: .26rem;
  font-size: .3rem;
  color: rgba(49,49,49,1);
  font-weight: 500;
}
.followHost{
  font-size:0.24rem;
  color:rgba(91,91,91,1);
  font-weight: 500;

 
}
.radioInfo{
  width: 100%;
  height: 1.3rem;
  display: flex;
  justify-content: start;
  overflow: hidden;
  margin-top: 0.1rem;
  border-bottom: 1px solid #ddd;
}
.radioInfo img{
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  margin-top: 0.25rem;
  margin-left: 0.42rem;
}
.radioInfo span{
  font-size: 0.3rem;
  color: #333;
  line-height: 1.3rem;
  margin-left: 0.1rem;
  max-width: 5.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.programinfo{
  margin-top: 5px;
  font-size: 0.26rem;
  color: #666666;
}
.programTitle{
  text-align: left;
  padding-left: 0.32rem;
  line-height: 0.8rem;
  font-size: 0.28rem;
  color: #333;
  font-weight: bold;
}
.programMassage{
  padding: 0 0.32rem;
  text-align: left;
  line-height: 0.35rem;
}
.downloadMsg{

box-sizing: border-box;
border-bottom: solid 2px rgba(221,221,221,0.6);
}
.downloadMsg p{
  height: 0.76rem;
  width: 4.4rem;
  margin:0.35rem auto 0.34rem;

}
.downloadMsg p img{
  width: 100%;
  height: 100%;
}

.comName {
  padding: 0.3rem 0 0.09rem 0.34rem;
  text-align: left;
  font-size: 0.42rem;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.85);
  // line-height:0.4rem;
}
.programStop {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.compere-stop {
  width: 100%;
  .radio {
    font-size: 0.24rem;
    color: rgba(255, 255, 255, 0.5);
    text-align: left;
    margin: 0.4px 0 0.14rem 0.3rem;
  }

  .display_window {
    width: 1.76rem;
    height: 0.56rem;
    margin-left: 0.3rem;
    padding: 0 0.16rem;
    background: rgba(0, 0, 0, 0.12);
    border-radius: 0.08rem;
    font-size: 0.2rem;
    color: #ffffff;
    justify-content: space-between;
    .img1 {
      width: 0.26rem;
      height: 0.24rem;
    }
    .img2 {
      width: 0.12rem;
      height: 0.2rem;
    }
  }
  .get {
    margin: 0.16rem 0 0.14rem 0.3rem;
    div {
      // margin-left: .32rem;
      .text_num {
        font-size: 0.28rem;
        color: white;
        margin-right: 0.12rem;
        font-weight: 700;
      }
      .text_text {
        font-size: 0.24rem;
        color: white;
        margin-right: 0.32rem;
      }
    }
  }
  .people {
    margin-left: .14rem;
    display: contents;
    .headmark{
      display: flex;
      align-items: center;
      position: relative;
    }
    .posi{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .avatar {
      width: 0.88rem;
      height: 0.88rem;
      border-radius: 100%;
    }
    .item{
      text-align: left;
      margin-right: .2rem;
      flex: none;
    .name {
      font-size: 0.22rem;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: .08rem;
    }
    }
    .tag {
      display: initial;
      padding: 0.04rem 0.1rem;
      margin-top: .08rem;
      // background: #13c2c2;
      border-radius: 2px;
      text-align: center;
      color: white;
      font-size: 0.2rem;
    }
  }
  .notice {
    height: 40px;
    margin: 0.16rem 0.26rem 0.28rem 0.3rem;
    padding: 0 0.3rem;
    background: rgba(56, 64, 75, 1);
    border-radius: 0.1rem;
    justify-content: space-between;
    .notice_text {
      font-size: 0.24rem;
      color: rgba(255, 255, 255, 0.5);
    }
    .time {
      font-size: 0.3rem;
      color: rgba(255, 255, 255, 0.85);
      margin-left: .24rem;
    }
    .img {
      width: 0.54rem;
      height: 0.54rem;
    }
  }
}
.table_bar_item{
  text-align: left;
  .title{
    margin-left: .52rem;
    margin-bottom: .32rem;
    font-size: .28rem;
    font-weight: 600;
    color: #000000;
  }
  .radio_name{
    margin-left: .52rem;
    font-size: .28rem;
    color: #F7B500;
    .spot{
      width: .12rem;
      height: .12rem;
      margin-right: .16rem;
      background: #F7B500;
      border-radius: 100%;
    }
  }
  .radio_text{
    margin: .32rem .52rem .46rem;
    font-size: .24rem;
    color: rgba(0, 0, 0, 0.8);
    line-height: .36rem;
  }
}
.compereMes {
  width: 100%;
}
.liveStop {
  width: 100%;
  height: 0.39rem;
  line-height: 0.39rem;
  box-sizing: border-box;
  display: inline-block;
  font-size: 0.42rem;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-top: 0.56rem;
  text-align: center;
}
.flex {
  display: flex;
  align-items: center;
}
.noList{
    height: 6.16rem;
    line-height: 6rem;
    color: rgba(153, 153, 153, 1);
    font-size: .34rem;
    text-align: center;
}
.table-bar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0.26rem 1rem 0.18rem 1rem;
  font-size: 0.3rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.5);
  .table-bar-item {
    margin-right: 0.46rem;
    height: 0.44rem;
    padding-bottom: 0.14rem;
  }
  .table-bar-item-active {
    position: relative;
    color: rgba(0, 0, 0, 1);
  }
  .table-bar-item-active b {
    position: absolute;
    bottom: 0.04rem;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    width: 0.46rem;
    height: 0.08rem;
    background: red;
    border-radius: 0.04rem;
  }
}
.tabContent{
    box-sizing: border-box;
  background: rgba(247, 247, 247, 1);
  border-radius: 0.5rem 0.5rem 0px 0px;
  overflow: hidden;
}
.header_download {
  width: 100%;
  height: 0.88rem;
  background: #e8e8e8;
  justify-content: space-between;
}
.header_download .logo2 {
  width: 0.72rem;
  height: 0.74rem;
  /* margin: 0.12rem 0 0.1rem 0.22rem; */
  margin: 0 0.28rem 0 0.48rem;
}
.header_download .voiceLogo2 {
  height: 0.4rem;
  width: auto;
}
.header_download .download {
  width: 1.42rem;
  height: 0.6rem;
  margin: 0.2rem 0.36rem 0.2rem 0;
}
::-webkit-scrollbar {
	/*隐藏滚轮*/
	display: none;
}




</style>
